module.exports = __webpack_public_path__ + "static/img/logo1.3183c1eb.png";